import { AnimationType } from '@ve-pro/enums/animation'
import type { SegmentCollection, SegmentText } from '@ve-pro/types/track.type'
import EventEmitter from 'eventemitter3'

interface VideoEvents {
  /**
   * 时间轴指针跳转事件
   */
  seek: (time: number, from?: string) => void
  /**
   * 左侧预览事件
   */
  preview: (segment: SegmentCollection) => void
  /**
   * 增加分片事件
   */
  addSegment: (segment: SegmentCollection) => void
  /**
   * 播放事件
   */
  play: () => void
  /**
   * 暂停事件
   */
  pause: () => void

  /**
   * 预览时间轴指针跳转事件
   */
  previewSeek: (time: number) => void

  /**
   * 预览动画
   */
  previewAnimation: (type: AnimationType) => void

  /**
   * 文本内容变更事件
   */
  textChange: (segments: SegmentText[]) => void
}

export const VideoEventter = new EventEmitter<VideoEvents>()
